import React from 'react'
import { useStatusReportContext } from './statusReportContext'
import StatusReportActionsDefaultLayout from './layouts/DefaultLayout/components/StatusReportActionsDefaultLayout'
import StatusReportActionsBoardLayout from './layouts/BoardLayout/components/StatusReportActionsBoardLayout'

function StatusReportActions (props) {
  const { variant } = useStatusReportContext()

  if (variant === 'board') {
    return <StatusReportActionsBoardLayout {...props} />
  }

  return <StatusReportActionsDefaultLayout {...props} />
}

export default StatusReportActions
